import { useState, useEffect } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../Sistema/Utils/Endpoints';
import { imagenNormalize } from '../Sistema/Objetos/ImagenesModel';
import { isMobile, isTablet } from 'react-device-detect';
import './../../style/Vars.css'
import './../../style/ElementsStyle.css'
import './../../style/ContainersStyles.css'
import img1 from './img/img1.jpeg';
import img2 from './img/img2.jpeg';
import img3 from './img/img3.jpeg';
import Header from './Header';
import Footer from './Footer';

const fallbackImages = [img1, img2, img3];

export default function FrontSigmaKey() {
  const [images, setImages] = useState(fallbackImages);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Cargar imágenes desde el servidor (S3 vía API)
  useEffect(() => {
    const loadBannerImages = async () => {
      try {
        const res = await axios.get(ENDPOINTS.imagenesSistema);
        const allImages = (res.data || []).map(x => imagenNormalize(x));

        // Según la base de datos: 
        // 1 = ImageIndex1, 2 = ImageIndex2, 3 = ImageIndex3
        const bannerImages = allImages
          .filter(img => [1, 2, 3].includes(Number(img.idTipoImagen)) && img.activo)
          .sort((a, b) => a.idTipoImagen - b.idTipoImagen)
          .map(img => img.imagenUrl);

        if (bannerImages.length > 0) {
          setImages(bannerImages);
        }
      } catch (error) {
        console.error("Error cargando imágenes de banner desde S3:", error);
      }
    };
    loadBannerImages();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="page-container">
      <Header />

      <div className="banner-container">
        <img src={images[currentIndex]} alt={`Banner ${currentIndex + 1}`} className="banner-image" />
        <div className="banner-overlay"></div>
      </div>

      <Footer />
    </div>
  );
}
